import { TitleOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { useState } from 'react';

import { graphql, type DocumentType } from '@/gql';

import { PostEditTitleDialog } from './edit-title-menu-item/PostEditTitleDialog';

const POST_EDIT_TITLE_MENU_ITEM_POST_FRAGMENT = graphql(`
  fragment postEditTitleMenuItemPostFragment on Post {
    ...postEditTitleDialog
  }
`);

interface Props {
  post: DocumentType<typeof POST_EDIT_TITLE_MENU_ITEM_POST_FRAGMENT>;
  onClose: () => void;
}

export const PostEditTitleMenuItem = ({ post, onClose }: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const { title } = post;

  return (
    <>
      <MenuItem
        onClick={() => {
          setDialogOpen(true);
          onClose();
        }}
      >
        <ListItemIcon>
          <TitleOutlined />
        </ListItemIcon>
        <ListItemText primary={title ? 'Edit title...' : 'Add title...'} />
      </MenuItem>
      <PostEditTitleDialog
        post={post}
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      />
    </>
  );
};
